<template>
  <form @submit.prevent="save">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-12">
        <b-field>
          <GovernmentAgencySelect v-model="form.source"
                                  :name="form.source__name"
                                  :label="`${$t('financingSources.source')} *`">
          </GovernmentAgencySelect>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-input :label="`${$t('financingSources.percent')} *`" type="number" v-model="form.percent"></form-input>
        </b-field>
      </div>
      <div class="column is-12">
        <div class="field is-grouped mt-10">
          <div class="control">
            <button type="submit" class="button is-primary">{{ $t('interface.save') }}</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click.prevent="cancel">{{ $t('interface.cancel') }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import GovernmentAgencySelect from '@/components/GovernmentAgencySelect'

  const defaultFinancingSourceData = {
    source: null,
    source__name: null,
    percent: 0
  }

  export default {
    props: ['financingSourceData', 'editMode'],
    components: {GovernmentAgencySelect},
    data() {
      return {
        form: this.financingSourceData || {...defaultFinancingSourceData},
        isEdit: this.editMode || false,
        errors: []
      }
    },
    methods: {
      validate() {
        this.errors = []
        if (this.form.source === null) {
          this.errors.push(this.$t('interface.requiredFields'))
        } else if (this.form.percent < 0) {
          this.errors.push(this.$t('financingSource.percentError'))
        }
        return this.errors.length === 0
      },
      save() {
        if (this.validate()) {
          this.$emit('save', this.form)
        }
      },
      cancel() {
        this.$router.go(-1)
      }
    },
    watch: {
      financingSourceData(data) {
        this.form = data
      }
    }
  }
</script>